import {Component} from "react";
import request from "request-promise-native";
import Alert from "react-bootstrap/lib/Alert";
import Form from "react-bootstrap/lib/Form";
import FormGroup from "react-bootstrap/lib/FormGroup";
import InputGroup from "react-bootstrap/lib/InputGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Button from "react-bootstrap/lib/Button";
import React from "react";

const LOGIN_ENDPOINT = "https://flexa-base.azurewebsites.net/api/Login";

class Login extends Component {
    constructor(props) {

        /*
            Props:
             - register
         */

        super(props);
        this.state = {
            loading: false
        };
        this.queryDict = {}
        window.location.search.substr(1).split("&").forEach(function(item) {
            this.queryDict[item.split("=")[0]] = item.split("=")[1]
        }.bind(this));
        console.log("Query dict:",this.queryDict);
        if(this.queryDict['code']==='200') {
            window.history.replaceState({}, "Login", "/");
        }
    }

    async logIn() {
        if(this.state.username==null || this.state.username==='') {
            this.setState({errorMessage:"Enter username!"});
            this.setState({
                username: ''
            })
            return;
        }
        if(this.state.password==null || this.state.password==='') {
            this.setState({errorMessage:"Enter password!"});
            this.setState({
                password: ''
            })
            return;
        }
        this.setState({loading: true, errorMessage: null});
        //Req to ms azure

        const options = {
            method: 'POST',
            uri: LOGIN_ENDPOINT,
            body: {
                username: this.state.username,
                password: this.state.password
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        this.setState({loading: false});

        if(response.statusCode!=200) {
            this.setState({errorMessage:"Invalid password or username!"});
            return;
        }

        console.log('Login success: '+response.body.code);

        this.props.onLogin(response.body.code);

    }

    render() {
        const usernameState = this.state.username!=null ? this.state.username === '' ? 'error' : 'success' : null;
        const passwordState = this.state.password!=null ? this.state.password === '' ? 'error' : 'success' : null;
        return (
            <div className="auth-wrapper d-flex no-block justify-content-center align-items-center bg-dark">
                <div className="auth-box bg-dark border-top border-secondary">
                    <div id="loginform">
                        {this.queryDict['code']==='200' ? <Alert bsStyle="success"><strong>Account activated successfully, login now!</strong></Alert> : ""}
                        <div className="text-center p-t-10 p-b-10">
                            <span className="db" style={{color:'white'}}><h2><b>BARIX</b> FLEXA ADMIN LOGIN</h2></span>
                        </div>
                        <div className="form-horizontal m-t-20" id="loginform">
                            <div className="row p-b-10">
                                <div className="col-12">
                                    <Form horizontal>
                                        <FormGroup controlId="name" validationState={usernameState}>
                                            <InputGroup>
                                                <InputGroup.Addon><i className="ti-user"></i></InputGroup.Addon>
                                                <FormControl type="text" onChange={(evnt) => {
                                                    this.setState({
                                                        username: evnt.target.value
                                                    });
                                                }} placeholder="Enter username" />
                                                <FormControl.Feedback />
                                            </InputGroup>
                                        </FormGroup>

                                        <FormGroup controlId="password" validationState={passwordState}>
                                            <InputGroup>
                                                <InputGroup.Addon><i className="ti-pencil"></i></InputGroup.Addon>
                                                <FormControl type="password" onChange={(evnt) => {
                                                    this.setState({
                                                        password: evnt.target.value
                                                    });
                                                }} placeholder="Enter password" />
                                                <FormControl.Feedback />
                                            </InputGroup>
                                        </FormGroup>
                                    </Form>
                                    {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                                        <strong>{this.state.errorMessage}</strong>
                                    </Alert>) : ''}
                                    {this.state.loading ? (<div className="p-t-30">
                                        <ProgressBar  active now={100} bsStyle="success" />;
                                    </div>) : ''}
                                </div>
                            </div>
                            <div className="row border-top border-secondary">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="p-t-20">
                                            <Button bsStyle="primary" onClick={this.props.forgotPassword}>
                                                Lost your password?
                                            </Button>
                                            <Button disabled={this.state.loading} onClick={this.logIn.bind(this)} bsStyle="primary" className="btn btn-success float-right">
                                                {this.state.loading ? 'Logging in...' : 'Login'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p></p>
                        <div className="separator" style={{
                            textAlign: 'center',
                            color: 'white'
                        }}>
                            <p className="change_link">Are you a partner? <a href="https://partner.barix.cloud/" className="to_register">Use a partner dashboard!</a>
                            </p>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;